import { useEffect, useRef, useState } from 'react';
import { useModal } from 'hooks/3cat/useModal';
import { useProducte } from 'hooks/3cat/useProducte';
import { useViewport } from 'hooks/useViewport';
import Imatge from 'components/3cat/Imatge';
import Boto from 'components/3cat/ui/Boto';
import Icona from 'components/3cat/ui/Icona';
import CodiEspectador from 'components/3cat/CodiEspectador';
import __isEmpty from 'lodash/isEmpty';
import __isUndefined from 'lodash/isUndefined';
import clsx from 'clsx';
import styles from './slider.module.scss';

const Info = (props) => {
    const { element } = props;
    const { title, abstract, promo } = element;

    return (
        <>
            {promo && (
                <span className={styles.avantitol} data-testid={'slide-avantitol'}>
                    {promo.toUpperCase()}
                </span>
            )}
            {!__isEmpty(title) && (
                <h3 className={styles.titol} data-testid={'slide-titol'}>
                    {title}
                </h3>
            )}
            {!__isEmpty(abstract) && (
                <div
                    className={styles.entradeta}
                    data-testid={'slide-entradeta'}
                    dangerouslySetInnerHTML={{ __html: abstract }}
                ></div>
            )}
        </>
    );
};

const ModalContingutTercers = (props) => {
    const { element } = props;
    const { isWebviewActive } = useProducte();
    const { title, abstract, images, button, age_rating, type, platform_text, platform_image, promo, duration } = element;
    const isVOD = type === 'VOD';
    const { isOnlyMobile } = useViewport();
    const { isMobile } = useViewport();
    const tancaRef = useRef();
    const { removeModal } = useModal();

    const codiEtic = age_rating === 0 ? 'TP' : `${age_rating}`;
    const closeModalHandler = (e) => {
        removeModal();
    };

    const tallarEntradeta = (abstract) => {
        const novaEntradeta = abstract.substring(0, 235);
        const ultimEspai = novaEntradeta.lastIndexOf(' ');
        let char = novaEntradeta[ultimEspai - 1];
        let _end = ultimEspai;
        if (char === ',' || char === ':' || char === '.') {
            _end--;
        }
        return [`${novaEntradeta.substring(0, _end)}...`];
    };
    const entradeta = isOnlyMobile && abstract.length > 235 ? tallarEntradeta(abstract) : abstract;

    const getContentDurada = (durada) => {
        return (
            <div className={styles.durada}>
                <Icona
                    className={styles.ico_clock}
                    icona='rellotge'
                    isBlanc={true}
                    mida='16'
                    alt='Icona rellotge'
                    ariaHidden={true}
                />
                <span>
                    <span className='sr-only'>Durada: </span>
                    {durada}
                </span>
            </div>
        );
    };

    const ShowBotons = () => {
        return (
            <div className={styles.contentBotonsModalContingutTercers}>
                <>
                    <Boto
                        text={button.label}
                        tag='a'
                        link={isWebviewActive ? button?.links?.android?.link || button?.link?.android : button.links?.web?.link}
                        className={styles.botoEnllacContingutTercersBlanc}
                        estil='none'
                        fons='fosc'
                        novaFinestra={true}
                        icona='ic_linkexterior'
                        isIconaDreta={true}
                        isIconaBlanc={false}
                    />
                    {!isOnlyMobile && (
                        <Boto
                            text='Continua a 3cat'
                            tag='button'
                            className={styles.botoEnllacContingutTercersNegre}
                            fons='fosc'
                            estil='none'
                            onClick={closeModalHandler}
                        />
                    )}
                </>
            </div>
        );
    };

    useEffect(() => {
        tancaRef?.current?.focus();
    }, []);

    return (
        <div className={styles.maskModalContingutTercers}>
            <div className={styles.overlayModalContingutTercers}>
                {isOnlyMobile && isWebviewActive && <div className={styles.capcaleraModalContingutTercers} />}
                <button
                    aria-label='Tanca'
                    className={isWebviewActive && isOnlyMobile ? styles.btn_tancaApp : styles.btn_tanca}
                    onClick={closeModalHandler}
                    ref={tancaRef}
                >
                    <Icona className={styles.ico_tanca} inline={true} icona='tanca' />
                </button>
                <div className={styles.wrapperImatgeModalContingutTercers}>
                    <div className={styles.imatgeModalContingutTercers}>
                        <Imatge
                            className={styles.imatge}
                            src={isMobile ? images.row_landscape : images.modal_portrait}
                            alt={title}
                            priority={false}
                            layout='fill'
                            objectFit='cover'
                        />
                    </div>
                    <div className={styles.wrapperLogoModalContingutTrecers}>
                        <div className={styles.logoModalContingutTercers}>
                            <Imatge src={images.platform_image_landscape || platform_image} priority={false} layout='fill' />
                        </div>
                    </div>
                </div>
                <div className={styles.wrapperModalContingutTercers}>
                    <div className={styles.textModalContingutTercers}>
                        {!isVOD && promo && <p>{promo.toUpperCase()}</p>}
                        <h2>{title}</h2>
                        <div className={styles.infoDurada}>
                            {codiEtic && (
                                <CodiEspectador className={styles.codiespectador} codi={codiEtic} alt={codiEtic} mida={20} />
                            )}
                            {isVOD && duration && getContentDurada(duration)}
                        </div>
                        {isOnlyMobile && <ShowBotons />}
                        <h4>{entradeta}</h4>
                    </div>
                    {!isOnlyMobile && <ShowBotons />}
                    {platform_text && (
                        <div className={styles.infoModalContingutTercers}>
                            <Icona icona='info_contorn' className={styles.play} alt='reproduir' isBlanc={true} mida={24} />
                            {platform_text}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const SlideContingutTercers = (props) => {
    const { element, midaImatge } = props;
    const [isHover, setIsHover] = useState(false);
    const [divHover, setDivHover] = useState('');
    const { title, images } = element;
    const { setModal } = useModal();

    const styleWrapper = clsx({
        [styles.wrapper]: true,
        [styles.wrapperContingutTercers]: true
    });

    useEffect(() => {
        setDivHover('');
        if (isHover) {
            setTimeout(() => {
                if (isHover) setDivHover(clsx({ [styles.itemHover]: true }));
            }, 200);
        }
    }, [isHover]);

    if (__isEmpty(title) && __isEmpty(images)) {
        return false;
    }

    const hoverHandler = (e) => {
        setIsHover(true);
    };
    const outHandler = () => {
        setIsHover(false);
    };

    const handleOnClick = () => {
        setModal(<ModalContingutTercers element={element} />, {
            className: styles.cameraModal,
            closeOnClickOutside: true,
            mode: 'full-screen'
        });
    };

    return (
        <>
            <div
                className={`${styleWrapper} ${divHover}`}
                onMouseEnter={hoverHandler}
                onMouseLeave={outHandler}
                onClick={handleOnClick}
            >
                <div className={styles.textWrapper}>
                    <Info element={element} />
                </div>

                <div className={styles.imatgeWrapper}>
                    <Imatge
                        className={styles.imatge}
                        src={images.row_portrait}
                        tipus={midaImatge}
                        alt={title}
                        priority={false}
                        mostrarRecursTitol={midaImatge !== 'web_keyframe'}
                        layout='fill'
                        objectFit='cover'
                    />
                </div>
            </div>
        </>
    );
};

SlideContingutTercers.defaultProps = {
    showLogoPlataforma: false
};

export default SlideContingutTercers;
